var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoanActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4238",
    "data-name": "Rectangle 4238",
    width: 26,
    height: 26,
    transform: "translate(719 478)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_02",
    "data-name": 2,
    transform: "translate(-719 -478)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "receipt-02",
    d: "M21.125,3.976c0-.011,0-.022-.022-.033a1.139,1.139,0,0,0-.921-.466,3.035,3.035,0,0,0-2.015,1.181A1.915,1.915,0,0,1,15.134,4.5L14.04,3.044a1.982,1.982,0,0,0-1.582-.878,1.982,1.982,0,0,0-1.582.878L9.772,4.507a1.905,1.905,0,0,1-3.012.162l-.011-.011C5.525,3.348,4.431,3.153,3.813,3.943c-.022.011-.022.022-.022.033A8.883,8.883,0,0,0,3.25,7.627V18.373a8.883,8.883,0,0,0,.542,3.651.082.082,0,0,0,.022.043c.628.78,1.712.585,2.936-.726l.011-.011a1.905,1.905,0,0,1,3.012.163l1.105,1.462a1.982,1.982,0,0,0,1.582.878,1.982,1.982,0,0,0,1.582-.878L15.134,21.5a1.915,1.915,0,0,1,3.033-.163,3.035,3.035,0,0,0,2.015,1.181,1.129,1.129,0,0,0,.921-.455.082.082,0,0,0,.022-.043,8.883,8.883,0,0,0,.542-3.651V7.627A8.883,8.883,0,0,0,21.125,3.976ZM15.167,15.708h-6.5a.813.813,0,0,1,0-1.625h6.5a.813.813,0,0,1,0,1.625Zm2.167-3.792H8.667a.813.813,0,0,1,0-1.625h8.667a.813.813,0,0,1,0,1.625Z",
    transform: "translate(718.75 477.833)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoanActive);
export default __webpack_public_path__ + "static/media/loan_active.e6f439b580fbaa561772abc8c8a9c65d.svg";
export { ForwardRef as ReactComponent };